// Module
var code = `<div class="login-page">
  <div class="login-card">

    <div class="login-brand">
      <i class="fas fa-tv fa-3x login-mark" aria-hidden="true"></i>
      <h1 class="jumbotron-title login-name">JumboTRON</h1>
    </div>

    <div class="jumbotron-surface login-surface">
      <div class="jumbotron-panel-head">
        <span class="jumbotron-heading">Signing in</span>
      </div>

      <div class="login-body">
        <div ng-if="\$ctrl.error" class="alert alert-danger py-2 mb-0" role="alert">
          <i class="fas fa-exclamation-circle me-1" aria-hidden="true"></i> {{ \$ctrl.error }}
        </div>

        <div class="login-wait" ng-if="!\$ctrl.error">
          <i class="fas fa-circle-notch fa-spin fa-2x login-mark" aria-hidden="true"></i>
          <p class="jumbotron-note login-lead">Signing you in, please wait...</p>
        </div>
      </div>
    </div>

    <p class="jumbotron-note login-footer">&copy; Roskilde Festival</p>
  </div>
</div>
`;
// Exports
export default code;